export default {"src":"/_next/static/image/public/images/ic_quickbooking.a669b655a5b4202f4095686915115a3d.svg","height":147,"width":129};